import VueRouter from 'vue-router';
import { Store } from 'vuex';
import namespaces from '@/store/namespaces';
import { I18nMutationTypes } from '@/store/modules/i18n/mutations';
import { I18nGetterTypes } from '@/store/modules/i18n/getters';

export default (router: VueRouter, store: Store<any>) => {
  router.beforeEach((to, from, next) => {
    if (to.meta.ignoreLocale) {
      next();
      return;
    }
    const defaultLocale = store.state[namespaces.I18N].fallbackLocale;
    const locale = to.params.LANG || defaultLocale;

    if (store.getters[`${namespaces.I18N}/${I18nGetterTypes.GET_LOCALES}`].indexOf(locale) === -1) {
      store.commit('SET_ERROR', { statusCode: 404 });
      next('/error');
      return;
    }

    store.commit(`i18n/${I18nMutationTypes.SET_LOCALE}`, locale);

    if (locale === defaultLocale && to.fullPath.indexOf('/' + defaultLocale) === 0) {
      const toReplace = '^/' + defaultLocale;
      const re = new RegExp(toReplace);
      next(to.fullPath.replace(re, '/'));
      return;
    }
    next();
  });
};
